import { redirect } from "next/navigation";
import { getSession } from "@/lib/auth/session";
import {
  IconActivity,
  IconBuilding,
  IconCreditCard,
  IconDashboard,
  IconFileText,
  IconScroll,
  IconTags,
  IconUsers,
} from "@/components/icons";
import { SidebarNav, type NavItem } from "./_components/sidebar-nav";
import { AdminShell } from "./_components/admin-shell";
import { CelestialBanner } from "./_components/celestial-banner";
import { CelestialMap } from "./_components/celestial-map";
import { CommandHint } from "./_components/command-hint";
import { UserMenu } from "./_components/user-menu";
import { MobileNav } from "./_components/mobile-nav";

export const dynamic = "force-dynamic";

const NAV: NavItem[] = [
  { href: "/dashboard", label: "Tableau de bord", icon: <IconDashboard size={18} /> },
  { href: "/tenants", label: "Tenants", icon: <IconBuilding size={18} /> },
  { href: "/billing", label: "Abonnements", icon: <IconCreditCard size={18} /> },
  { href: "/plans", label: "Plans", icon: <IconTags size={18} /> },
  { href: "/techniciens", label: "Techniciens", icon: <IconUsers size={18} /> },
  { href: "/report-templates", label: "Templates rapports", icon: <IconFileText size={18} /> },
  { href: "/monitoring", label: "Monitoring", icon: <IconActivity size={18} /> },
  { href: "/activites", label: "Journal", icon: <IconScroll size={18} /> },
];

export default async function AdminLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const session = await getSession();
  if (!session) redirect("/login");
  const user = session.user;

  return (
    <div className="flex min-h-screen">
      <aside className="hidden w-64 flex-col border-r border-sidebar-active/40 bg-sidebar text-sidebar-foreground md:flex">
        <div className="flex items-center gap-3 border-b border-sidebar-active/60 px-5 py-5">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-sidebar-accent/15 text-sidebar-accent ring-1 ring-sidebar-accent/30">
            <span className="text-sm font-bold tracking-tighter">mf</span>
          </div>
          <div className="min-w-0">
            <p className="text-[10px] uppercase tracking-[0.18em] text-sidebar-muted">
              missioflow
            </p>
            <p className="text-sm font-semibold leading-tight">SuperAdmin</p>
          </div>
        </div>

        <CommandHint />
        <SidebarNav items={NAV} />

        <div className="border-t border-sidebar-active/60 p-2">
          <UserMenu user={{ name: user.name, email: user.email }} />
        </div>
      </aside>

      <main className="relative min-w-0 flex-1 bg-background flex flex-col">
        <CelestialMap />
        <div className="mf-admin-shell relative z-10 flex flex-1 flex-col">
          <MobileNav userName={user.name} userEmail={user.email} />
          <CelestialBanner />
          <div className="flex-1">
            <AdminShell>{children}</AdminShell>
          </div>
        </div>
      </main>
    </div>
  );
}
